var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated FadeIn"},[_c('CharacterInfo',{attrs:{"loadingCharacter":_vm.loadingCharacter,"item":_vm.character}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }